import React from 'react';
import { Progress } from 'reactstrap';
import './styles.scss';

// Currently there are 5 colors: blue (default), green ("success"), turquoise ("info"), yellow ("warning"), red ("danger") 
const ProgressControl = (props) => (
  <div className={`progressControl ${props && props.extraClass}`}>
    <Progress 
        animated={props.animated}
        className={`progressControl__bar ${props.className || ""}`}
        color={props.color}
        value={props.value}
    >
        <span className="progressControl__text">{props.label}</span>
    </Progress>
  </div>
);

export default ProgressControl;



// WEBPACK FOOTER //
// ./src/components/LoadingStyles/ProgressControl.js